import { action, makeObservable } from 'mobx';
import { LocalStorageItemState } from 'src/domains/layouts/state/localStorage/LocalStorageItemState';
import { Common } from 'src/domains/common/Common';
import { LocalStorageState } from 'src/domains/layouts/state/localStorage/LocalStorageState';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';

const isWebpackHotSession = (): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }

    return window.$hotAppWrapperInst !== undefined;
};

export class SocketStatsBarState {
    public readonly visible: LocalStorageItemState<boolean>;

    public static get = AutoWeakMap.create((common: Common) => new SocketStatsBarState(common));

    private constructor(private readonly common: Common) {
        makeObservable(this);
        const localStorageState = LocalStorageState.get(common);
        this.visible = localStorageState.socketStatsBar;
    }

    public get shouldRender(): boolean {
        const envAllowsDebugBar = this.common.envVariables.isProdMode === false || isWebpackHotSession();

        return this.common.isBrowser && envAllowsDebugBar && this.visible.getValue();
    }

    @action public hide(): void {
        this.visible.setValue(false);
    }

    @action public show(): void {
        this.visible.setValue(true);
    }

    @action public toggle(): void {
        this.visible.setValue(!this.visible.getValue());
    }
}
